import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, } from 'react';
export function createAppComponentsContext() {
    return createContext(null);
}
export const AppComponentsContext = createAppComponentsContext();
export function AppComponentsProvider({ children, ...components }) {
    return (_jsx(AppComponentsContext.Provider, { value: components, children: children }));
}
